import React from "react";
import { useFormState } from "react-final-form";
import { useTranslation } from "react-i18next";
import TimeService from "src/services/timeService/timeService";

import { Box, Typography } from "@mui/material";
import { PrimaryButton, SecondaryButton } from "@shared/CustomButton";
import { TextareaField } from "@shared/form/TextareaField";

import { countSelectedDevices, RolloutFormValues, ScheduleType } from "../CreateRolloutSidePanel.utils";
import { ScheduleDateFormat } from "../ScheduleStep/schedule.validation";

import { useStyles } from "./ConfirmStep.styles";

type Props = {
    onBack: () => void;
};

export const ConfirmStep = (props: Props) => {
    const { classes } = useStyles();
    const { t } = useTranslation(["sidepanels", "common"]);
    const { values } = useFormState<RolloutFormValues>();
    const selectedDeviceCount = countSelectedDevices(values);

    const scheduleLabel =
        values?.scheduleType === ScheduleType.TimeWindow && values?.windowStart && values?.windowEnd
            ? t("rolloutPanel.confirm.scheduleTimeWindow", {
                  start: TimeService.getFromMillis(values.windowStart.getTime()).toFormat(ScheduleDateFormat),
                  end: TimeService.getFromMillis(values.windowEnd.getTime()).toFormat(ScheduleDateFormat),
              })
            : t("rolloutPanel.confirm.scheduleWhenFound");

    return (
        <React.Fragment>
            <Box className={classes.content}>
                <Box className={classes.root}>
                    <Box className={classes.summaryBox}>
                        <Box className={classes.row}>
                            <Typography variant="body2" className={classes.label}>
                                {t("rolloutPanel.devicesToUpdate")}
                            </Typography>
                            <Typography variant="body2" className={classes.value}>
                                {t("rolloutPanel.confirm.devicesCount", { count: selectedDeviceCount })}
                            </Typography>
                        </Box>
                        <Box className={classes.row}>
                            <Typography variant="body2" className={classes.label}>
                                {t("rolloutPanel.schedule.title")}
                            </Typography>
                            <Typography variant="body2" className={classes.value}>
                                {scheduleLabel}
                            </Typography>
                        </Box>
                    </Box>

                    <Box>
                        <Typography variant="subtitle2" className={classes.notesLabel}>
                            {t("rolloutPanel.internalComment")}
                        </Typography>
                        <TextareaField name="notes" rows={6} fullWidth />
                    </Box>
                </Box>
            </Box>
            <Box className={classes.footer}>
                <SecondaryButton onClick={props.onBack}>{t("common:button.back")}</SecondaryButton>
                <PrimaryButton type="submit">{t("sidepanels:rolloutPanel.button.createRollout")}</PrimaryButton>
            </Box>
        </React.Fragment>
    );
};
